var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', [_c('images-basic'), _c('images-responsive'), _c('images-thumbnails'), _c('images-rounded-corner'), _c('images-alignment'), _c('images-blank'), _c('images-lazy')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }